import React from 'react';
import { Stat } from '../../../CommonComponents/OPL/Stat/Stat';
import { StatError } from '../../../CommonComponents/OPL/Stat/Stat.error';
import { StatLoading } from '../../../CommonComponents/OPL/Stat/Stat.loading';
import { useMarketValue } from './useMarketValue';

export const MarketValue: React.FC = () => {
  const { isFetching, isError, refetch, data } = useMarketValue();

  if (isFetching) {
    return <StatLoading />;
  }

  if (isError) {
    return <StatError onRetry={refetch} />;
  }

  if (!data) {
    return null;
  }

  const { label, value } = data;

  return <Stat label={label} value={value || '–'} />;
};
